(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55],{

/***/ 836:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return __webpack_require__(8773);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8767);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1894);
/* harmony import */ var _coreui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4475);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9765);
/* harmony import */ var parts_landingpage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(806);
/* harmony import */ var parts_blogs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8588);
/* harmony import */ var parts_courier_services__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5267);
/* harmony import */ var utils_useLoading__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(471);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2962);
/* harmony import */ var redux_toggleSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9756);
/* harmony import */ var components_ResponseErrorServerSide__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(577);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_14__);
/* eslint-disable jsx-a11y/alt-text */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable react/jsx-no-undef */ /* eslint-disable no-unused-vars */ 
















function Blogs(param) {
    var product = param.product, landingPage = param.landingPage, headerFooter = param.headerFooter, coverageArea = param.coverageArea, blogs = param.blogs, isError = param.isError, lang = param.lang;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    // const language = useSelector((state) => state.toggle.language);
    var language = lang;
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), visible = ref19[0], setVisible = ref19[1];
    var prevScrollY = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), goingUp = ref20[0], setGoingUp = ref20[1];
    var loading = (0,utils_useLoading__WEBPACK_IMPORTED_MODULE_10__/* .useLoading */ .r)(false);
    // blogs
    var meta = {
        currentPage: blogs === null || blogs === void 0 ? void 0 : (ref = blogs.state) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.currentPage,
        pageCount: blogs === null || blogs === void 0 ? void 0 : (ref2 = blogs.state) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.meta) === null || ref3 === void 0 ? void 0 : ref3.pageCount
    };
    var dataPost = blogs === null || blogs === void 0 ? void 0 : (ref4 = blogs.state) === null || ref4 === void 0 ? void 0 : ref4.data;
    // ===
    // seo
    var seo = product === null || product === void 0 ? void 0 : product.state;
    // ===
    // navbar
    var navbar = headerFooter === null || headerFooter === void 0 ? void 0 : (ref5 = headerFooter.state) === null || ref5 === void 0 ? void 0 : ref5.header;
    // ===
    // banner
    var banner = landingPage === null || landingPage === void 0 ? void 0 : (ref6 = landingPage.state) === null || ref6 === void 0 ? void 0 : ref6.banner;
    // ===
    // coverageArea
    var CoverageArea = [];
    coverageArea === null || coverageArea === void 0 ? void 0 : (ref7 = coverageArea.state) === null || ref7 === void 0 ? void 0 : ref7.forEach(function(item) {
        CoverageArea.push(item.jvector_code);
    });
    // ===
    // navigasi menu
    var navigasiMenu = landingPage === null || landingPage === void 0 ? void 0 : (ref8 = landingPage.state) === null || ref8 === void 0 ? void 0 : ref8.navigationMenu;
    // ===
    // hero
    var newDataHeader = {
        banner_img: product === null || product === void 0 ? void 0 : (ref9 = product.state) === null || ref9 === void 0 ? void 0 : ref9.banner_img,
        cta_btn_id: product === null || product === void 0 ? void 0 : (ref10 = product.state) === null || ref10 === void 0 ? void 0 : ref10.cta_btn_id,
        en_desc: product === null || product === void 0 ? void 0 : (ref11 = product.state) === null || ref11 === void 0 ? void 0 : ref11.en_desc,
        en_title: product === null || product === void 0 ? void 0 : (ref12 = product.state) === null || ref12 === void 0 ? void 0 : ref12.en_title,
        id_desc: product === null || product === void 0 ? void 0 : (ref13 = product.state) === null || ref13 === void 0 ? void 0 : ref13.id_desc,
        id_title: product === null || product === void 0 ? void 0 : (ref14 = product.state) === null || ref14 === void 0 ? void 0 : ref14.id_title,
        headerCTA: product === null || product === void 0 ? void 0 : (ref15 = product.state) === null || ref15 === void 0 ? void 0 : ref15.headerCTA,
        additional_cta_btn_id: product === null || product === void 0 ? void 0 : (ref16 = product.state) === null || ref16 === void 0 ? void 0 : ref16.additional_cta_btn_id,
        additionalCTA: product === null || product === void 0 ? void 0 : (ref17 = product.state) === null || ref17 === void 0 ? void 0 : ref17.additionalCTA
    };
    var dataHero = newDataHeader;
    // ===
    // cta fixed
    var dataCTA = product === null || product === void 0 ? void 0 : product.state;
    var newCTAFixed = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, dataCTA === null || dataCTA === void 0 ? void 0 : dataCTA.stickyCTA), {
        sticky_cta_btn_id: dataCTA === null || dataCTA === void 0 ? void 0 : dataCTA.sticky_cta_btn_id
    });
    var dataCTAFixed = newCTAFixed;
    // footer
    var footer = headerFooter === null || headerFooter === void 0 ? void 0 : (ref18 = headerFooter.state) === null || ref18 === void 0 ? void 0 : ref18.footer;
    // ===
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var handleScroll = function() {
            if (true) {
                var ref;
                var currentScrollY = window.scrollY;
                if ((prevScrollY === null || prevScrollY === void 0 ? void 0 : prevScrollY.current) < currentScrollY && goingUp) {
                    setGoingUp(false);
                }
                if ((prevScrollY === null || prevScrollY === void 0 ? void 0 : prevScrollY.current) > currentScrollY && !goingUp) {
                    setGoingUp(true);
                }
                var startY = (ref = document.querySelectorAll(".codrops-top-for-page-detail")[0]) === null || ref === void 0 ? void 0 : ref.clientHeight;
                prevScrollY.current = currentScrollY;
                //
                if (currentScrollY > startY) {
                    var ref1;
                    var el = document.querySelectorAll(".codrops-top-for-page-detail")[0];
                    el === null || el === void 0 ? void 0 : (ref1 = el.classList) === null || ref1 === void 0 ? void 0 : ref1.add("scrolled");
                } else {
                    var ref2;
                    var el1 = document.querySelectorAll(".codrops-top-for-page-detail")[0];
                    el1 === null || el1 === void 0 ? void 0 : (ref2 = el1.classList) === null || ref2 === void 0 ? void 0 : ref2.remove("scrolled");
                }
            }
        };
        if (((ref = document.querySelectorAll(".codrops-top-for-page-detail")[0]) === null || ref === void 0 ? void 0 : ref.clientHeight) > 0) {
            if (true) {
                window.addEventListener("scroll", function() {
                    handleScroll();
                });
                window.addEventListener("load", function() {
                    handleScroll();
                });
                window.addEventListener("resize", function() {
                    handleScroll();
                });
            }
        }
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        goingUp
    ]);
    var handleChangeLanguage = function() {
        if (language === "EN") {
            dispatch((0,redux_toggleSlice__WEBPACK_IMPORTED_MODULE_12__/* .setToggle */ .rd)({
                language: "ID"
            }));
            router.push("/blogs", "/blogs", {
                locale: "id"
            });
        } else {
            dispatch((0,redux_toggleSlice__WEBPACK_IMPORTED_MODULE_12__/* .setToggle */ .rd)({
                language: "EN"
            }));
            router.push("/blogs", "/blogs", {
                locale: "en"
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // check first load
        if (language === "ID") {
            dispatch((0,redux_toggleSlice__WEBPACK_IMPORTED_MODULE_12__/* .setToggle */ .rd)({
                language: "ID"
            }));
        }
        if (language === "EN") {
            dispatch((0,redux_toggleSlice__WEBPACK_IMPORTED_MODULE_12__/* .setToggle */ .rd)({
                language: "EN"
            }));
        }
    }, []);
    var topFunction = function() {
        setVisible(function(currentValue) {
            return !currentValue;
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var openNav = function() {
        document.getElementById("mySidenav").style.width = "320px";
    };
    var closeNav = function() {
        document.getElementById("mySidenav").style.width = "0";
    };
    if (loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_6__/* .LoadingScreen */ .a_, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ResponseErrorServerSide__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_11__/* .NextSeo */ .PB, {
                title: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_seo_page_title : seo === null || seo === void 0 ? void 0 : seo.en_seo_page_title,
                description: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_meta_desc : seo === null || seo === void 0 ? void 0 : seo.en_meta_desc,
                additionalMetaTags: [
                    {
                        property: "keywords",
                        content: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_meta_keyword : seo === null || seo === void 0 ? void 0 : seo.en_meta_keyword
                    }
                ],
                additionalLinkTags: [
                    {
                        rel: "canonical",
                        href: "".concat("https://cklnext.lyrid.id/").concat(language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_slug : seo === null || seo === void 0 ? void 0 : seo.en_slug)
                    },
                    {
                        rel: "icon",
                        href: navbar === null || navbar === void 0 ? void 0 : navbar.web_icon
                    }
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_coreui_react__WEBPACK_IMPORTED_MODULE_5__/* .CCollapse */ .V9, {
                        visible: visible,
                        id: "collapse-top-index",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "card card-body",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_6__/* .BackgroundBannerDefault */ .M4, {
                                    data: banner,
                                    language: language
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(parts_landingpage__WEBPACK_IMPORTED_MODULE_7__/* .MainContent */ .M9, {
                                    language: language,
                                    data: navigasiMenu,
                                    CoverageArea: CoverageArea
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        id: "col-top-nav",
                        className: "codrops-top codrops-top-for-page-detail",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(parts_courier_services__WEBPACK_IMPORTED_MODULE_9__/* .NavbarCourierServices */ .O, {
                                topFunction: topFunction,
                                data: navbar,
                                changeLanguage: handleChangeLanguage,
                                language: language
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_6__/* .Sidebar */ .DD, {
                                changeLanguage: handleChangeLanguage,
                                closeNav: closeNav,
                                openNav: openNav,
                                topFunction: topFunction,
                                data: navbar,
                                language: language
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-main-page col-main-page-detail",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(parts_blogs__WEBPACK_IMPORTED_MODULE_8__/* .CustomHero */ .TV, {
                                breadcrump: navbar,
                                language: language,
                                dataHeader: dataHero
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(parts_blogs__WEBPACK_IMPORTED_MODULE_8__/* .Items */ .ob, {
                                data: dataPost,
                                language: language,
                                currentPage: meta.currentPage,
                                pageSize: meta.pageCount
                            })
                        ]
                    }),
                    (dataCTAFixed === null || dataCTAFixed === void 0 ? void 0 : dataCTAFixed.sticky_cta_btn_id) !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_6__/* .WAFixed */ .Fs, {
                        data: dataCTAFixed
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_6__/* .FooterFrontend */ .YE, {
                        footer: footer,
                        language: language
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Blogs);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* unused reexport */ __webpack_require__(699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,617,645,498,383,74,806,482,774,888,179], function() { return __webpack_exec__(836); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);